import { RootState } from "../types";

export const chatConnectionSelector = (state: RootState) =>
  state.chat.connection;
export const chatUsersSelector = (state: RootState) =>
  state.chat.chatData.conversations;

export const chatCurrentUserIdSelector = (state: RootState) =>
  state.chat.chatData.currentUserId;
export const allConnectedUsersSelector = (state: RootState) =>
  state.chat.allConnectedUsers;
export const callEndedSelector = (state: RootState) => state.chat.callEnded;
export const unSeenChatMessagesSelector = (state: RootState) =>
  state.chat.unSeenChatMessages;